// extracted by css-extract-rspack-plugin
export default {"navigation":"1000","header":"1000","listHeader":"10"};